import React, { useState } from "react";
import { arrayOf, bool, object, string, number } from "prop-types";
import { useTranslation } from "@lib/i18n";

import CollapsableContainer from "@components/shared/CollapsableContainer";
import Typography from "@components/shared/Typography";

import { JOURNEY_TYPE } from "@shared/constants";

import FinanceDisplayBlocks, {
  DISPLAY_BLOCKS_VARIANT,
} from "./FinanceDisplayBlocks";

const TotalFinanceFinancing = ({
  shouldDisplayError,
  financialProductLabel,
  displayBlocks,
  journey,
  isQuantityVisible,
  vehicleQuantity,
}) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  const getDisplayBlocksVariant = journey => {
    switch (journey) {
      case JOURNEY_TYPE.LOA:
        return DISPLAY_BLOCKS_VARIANT.COMPACT;

      case JOURNEY_TYPE.VAC:
        return DISPLAY_BLOCKS_VARIANT.WORDY;

      case JOURNEY_TYPE.LLD:
      default:
        return DISPLAY_BLOCKS_VARIANT.DEFAULT;
    }
  };

  const subtitle =
    vehicleQuantity > 1
      ? t("basket.totalPaymentSubtitle.plural", {
          count: vehicleQuantity,
        })
      : t("basket.totalPaymentSubtitle.singular", {
          count: vehicleQuantity,
        });

  return (
    <CollapsableContainer
      className={{
        wrap: "-mx-1 mt-8",
      }}
      isOpen={isOpen}
      onChange={() => setOpen(!isOpen)}
      subTitle={subtitle}
      title={<span className="text-lg">{t("basket.totalPaymentTitle")}</span>}
    >
      {shouldDisplayError ? (
        <Typography className="flex justify-center items-center text-black text-center font-semibold min-h-40">
          {t("financeDataErrorMessage")}
        </Typography>
      ) : (
        <>
          <Typography className="text-lg font-semibold">
            {financialProductLabel}
          </Typography>
          <FinanceDisplayBlocks
            displayBlocks={displayBlocks}
            variant={getDisplayBlocksVariant(journey)}
            isQuantityVisible={isQuantityVisible}
            vehicleQuantity={vehicleQuantity}
          />
        </>
      )}
    </CollapsableContainer>
  );
};

TotalFinanceFinancing.propTypes = {
  shouldDisplayError: bool.isRequired,
  financialProductLabel: string.isRequired,
  displayBlocks: arrayOf(object).isRequired,
  journey: string.isRequired,
  isQuantityVisible: bool,
  vehicleQuantity: number,
};

export default TotalFinanceFinancing;
